import React, {useState} from "react";
import {PropertyLine} from "./PropertyLine";

export const FeatureBox = ({node}) => {
    const _node = node || {}

    let _features = []
    if (_node && _node.features) {
        for (const [key, value] of Object.entries(_node.features)) {
            //_features.push(<FeatureLine key={key} feature={{key, value}}/>)
            _features.push(<PropertyLine key={key+"path"} uid={node?.uid} keyname={key} name={key} value={value} readonly={false}/>)
        }
    }

    return (
        <div>
            {_features}
        </div>
    )
}
